import { ApiClientBase } from "../framework/services/api-client-base";
import { isNullOrWhitespace, isThisLocalhost } from "../framework/utils";
import { CustomerAccountService } from "./customer-account";
import { localhostApi } from "./localhost-api";
import * as $http from 'superagent';

class ApiClientClass extends ApiClientBase {
    constructor() {
        super();

        this.host = isThisLocalhost() ? localhostApi : window.location.origin;
        this.host = this.host + '/api';
    }
    
    protected acquireToken(): Promise<string> {
        return Promise.resolve('');
    }

    protected preSendRequestAction(req: $http.SuperAgentRequest): void {
        const token = CustomerAccountService.getAccountToken();
        if(isNullOrWhitespace(token)) { return; }

        req.set('x-storm-customer', token!);
    }

    protected failedRequestAction(resp: $http.Response): void {
        if(resp.status === 401) {
            CustomerAccountService.signOut();
        }
    }
}

export const ApiClient = new ApiClientClass();